import Modal from './Modal';
import './KeyboardShortcutsHelp.css';

interface ShortcutGroup {
  title: string;
  shortcuts: Array<{
    keys: string[];
    description: string;
  }>;
}

const shortcutGroups: ShortcutGroup[] = [
  {
    title: 'Navegación',
    shortcuts: [
      { keys: ['Ctrl', 'K'], description: 'Abrir búsqueda global' },
      { keys: ['Ctrl', 'F'], description: 'Abrir búsqueda' },
      { keys: ['F5'], description: 'Actualizar datos' },
      { keys: ['Ctrl', 'R'], description: 'Actualizar datos' },
      { keys: ['Esc'], description: 'Cerrar modales/diálogos' },
    ],
  },
  {
    title: 'Acciones',
    shortcuts: [
      { keys: ['Ctrl', 'N'], description: 'Nuevo elemento (donde aplique)' },
      { keys: ['Ctrl', 'S'], description: 'Guardar (donde aplique)' },
      { keys: ['F1'], description: 'Mostrar ayuda' },
    ],
  },
];

interface KeyboardShortcutsHelpProps {
  isOpen: boolean;
  onClose: () => void;
  customShortcuts?: ShortcutGroup[];
}

export default function KeyboardShortcutsHelp({
  isOpen,
  onClose,
  customShortcuts,
}: KeyboardShortcutsHelpProps) {
  const allGroups = customShortcuts
    ? [...shortcutGroups, ...customShortcuts]
    : shortcutGroups;

  const formatKey = (key: string): string => {
    const keyMap: { [key: string]: string } = {
      Ctrl: 'Ctrl',
      Shift: 'Shift',
      Alt: 'Alt',
      Meta: '⌘',
      Escape: 'Esc',
      Enter: 'Enter',
      Backspace: '⌫',
      Delete: 'Del',
      ArrowUp: '↑',
      ArrowDown: '↓',
      ArrowLeft: '←',
      ArrowRight: '→',
    };

    return keyMap[key] || key;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Atajos de Teclado">
      <div className="keyboard-shortcuts-help">
        {allGroups.map((group, groupIndex) => (
          <div key={groupIndex} className="shortcut-group">
            <h3 className="shortcut-group-title">{group.title}</h3>
            <div className="shortcut-list">
              {group.shortcuts.map((shortcut, index) => (
                <div key={index} className="shortcut-item">
                  <div className="shortcut-keys">
                    {shortcut.keys.map((key, keyIndex) => (
                      <span key={keyIndex}>
                        <kbd className="shortcut-key">{formatKey(key)}</kbd>
                        {keyIndex < shortcut.keys.length - 1 && (
                          <span className="shortcut-separator">+</span>
                        )}
                      </span>
                    ))}
                  </div>
                  <div className="shortcut-description">{shortcut.description}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
        <div className="shortcut-footer">
          <p className="shortcut-hint">
            💡 Los atajos pueden variar según el contexto. Algunos atajos solo funcionan cuando no estás escribiendo en un campo de texto.
          </p>
        </div>
      </div>
    </Modal>
  );
}

